<template>
    <div class="p-3">
        <div class="">
            <div class="d-flex justify-content-between align-items-center">
                <span v-if="!goal.parameters.time_limit"
                    >Elapsed time: <b>{{ helpers.secondsToMinutes(elapsedTime) }}</b></span
                >
                <span v-else=""
                    >Remaining time: <b>{{ helpers.secondsToMinutes(remainingTime) }}</b></span
                >
                <button
                    :disabled="isTimerRunning || (goal.parameters.time_limit && remainingTime <= 0)"
                    class="btn btn-link btn font-weight-bold"
                    @click="startTimer"
                >
                    Start timer
                </button>
            </div>
            <div
                v-for="(target, i) in goal.parameters.targets"
                class="w-100 m-2 btn"
                :class="
                    isTimerRunning ? 'btn-primary text-white' : 'btn-outline-primary text-primary'
                "
                @click="addAttempt(target, i)"
            >
                <span class="d-flex justify-content-start align-items-center font-weight-bold">
                    <span class="mr-2">{{ results[target] || 0 }}</span>
                    <span>{{ target }}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MultiTally",
    props: ["goal", "date", "customization", "notesData"],
    data() {
        return {
            interval: null,
            currentTime: this.moment(),
            startTime: this.moment(),
            results: {},
            runTime: 0,
            undoStack: [],
            isTimerRunning: false,
        };
    },
    created() {
        if (this.goal) {
            this.interval = setInterval(this.updateCurrentTime, 1000);
        }
    },
    mounted() {
        this.setupResults();
    },
    computed: {
        elapsedTime() {
            return this.isTimerRunning ? this.currentTime.diff(this.startTime, "seconds") : 0;
        },
        remainingTime() {
            if (this.goal.parameters.time_limit) {
                return Math.max(
                    0,
                    this.isTimerRunning
                        ? this.goal.parameters.time_limit -
                              this.currentTime.diff(this.startTime, "seconds")
                        : this.goal.parameters.time_limit
                );
            }
            return 0;
        },
    },
    methods: {
        setupResults() {
            this.goal.parameters.targets.forEach(target => {
                this.results[target] = 0;
            });
        },
        reportResult(success) {
            this.$emit("saved", success);
            if (success) {
                let perTargetReport = "";
                [...this.goal.parameters.targets].forEach(target => {
                    perTargetReport += `${target}: ${this.results[target]} - `;
                });
                this.$emit(
                    "close-tracker",
                    this.goal.title + " scores: " + `${perTargetReport}` + this.notesData
                );
            }
        },
        saveTrackerData() {
            const totalElapsedTime = this.goal.parameters.time_limit
                ? Math.min(this.goal.parameters.time_limit, this.elapsedTime)
                : this.elapsedTime;

            let data = {
                session_at: this.date
                    ? this.moment(this.date).format("YYYY-MM-DD HH:mm:ss")
                    : this.moment().format("YYYY-MM-DD HH:mm:ss"),
                notes: this.notesData,
                data: {
                    type: "multi_tally",
                    results: { ...this.results },
                    time: totalElapsedTime,
                },
            };

            axios
                .post(`/api/patients/${this.goal.patient.id}/goals/${this.goal.id}/trackers`, data)
                .then(r => {
                    this.reportResult(true);
                })
                .catch(error => {
                    this.$emit("save-draft", { error, data });
                    this.reportResult(false);
                    this.$swal({
                        title: "Error!",
                        text: "An error occurred while saving.",
                        type: "error",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#d64571",
                    });
                    console.error(error);
                });
        },

        addAttempt(target) {
            if (this.goal.parameters.time_limit && this.remainingTime <= 0) return;
            this.results[target]++;
            this.undoStack.push(target);
            if (!this.isTimerRunning) {
                this.startTimer();
            }
        },

        updateCurrentTime() {
            if (this.goal.parameters.time_limit && this.remainingTime <= 0) {
                this.isTimerRunning = false;
            }
            this.currentTime = this.moment();
        },

        startTimer() {
            if (
                !this.isTimerRunning &&
                !(this.goal.parameters.time_limit && this.remainingTime <= 0)
            ) {
                this.startTime = this.moment();
                this.isTimerRunning = true;
            }
        },

        undoAttempt() {
            if (this.undoStack.length) {
                this.results[this.undoStack.pop()]--;
            }
        },
    },
};
</script>
